import * as React from "react";
import { DocumentCard, DocumentCardPreview, DocumentCardTitle, ImageFit } from "office-ui-fabric-react";
var icons = ["https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/32/docx.svg", "https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/32/xlsx.svg", "https://spoprod-a.akamaihd.net/files/fabric/assets/item-types/32/pptx.svg"];
export var DocumentCardBasic = function DocumentCardBasic(props) {
  var _a;

  return React.createElement(DocumentCard, {
    "aria-label": props.template.title,
    type: props.cardType,
    onClick: function onClick() {
      props.onClick(props.template);
    }
  }, React.createElement(DocumentCardPreview, {
    previewImages: [{
      name: props.template.title,
      previewImageSrc: props.template.imageURL || icons[props.template.hostType],
      iconSrc: icons[props.template.hostType],
      imageFit: ImageFit.cover,
      width: 250,
      height: 150
    }]
  }), React.createElement("div", {
    className: "documentCardcontent"
  }, React.createElement(DocumentCardTitle, {
    title: props.template.title,
    shouldTruncate: true
  }), React.createElement(DocumentCardTitle, {
    className: "description",
    title: props.template.description || props.strings.NoDescriptionText,
    shouldTruncate: true,
    showAsSecondaryTitle: true
  }), React.createElement(DocumentCardTitle, {
    className: "tags",
    title: ((_a = props.template.tags) === null || _a === void 0 ? void 0 : _a.join(", ")) || props.strings.NoTagsText,
    shouldTruncate: true,
    showAsSecondaryTitle: true
  })));
};